import { useAuth } from "../Context/AuthContext"
import { Navigate, useNavigate } from "react-router-dom"
export const RequireOTP = ({children}) =>{
    const auth = useAuth()
    const navigate = useNavigate();
    if (auth.otp===true){
        console.log('auth.userInfo')
        console.log('UserInfo:', auth.userInfo)
        return children
    }
    else{
      console.log('!auth.userInfo')
      console.log(auth)
      return <Navigate to="/login" />
      // navigate("/login", {replace:true})
    }
    
    
}